import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import cn from 'classnames';
import Tooltip from '@omilia/tooltip';

import Annotation from './components/Annotation';
import './style.scss';

export default class AnnotationPopup extends Component {
  static propTypes = {
    annotations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        token: PropTypes.string,
      }),
    ),
    position: PropTypes.shape({
      left: PropTypes.string,
      top: PropTypes.string,
    }),
    token: PropTypes.string,
    onClose: PropTypes.func,
  };

  state = {
    isExpanded: true,
  };

  handleClick = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  render() {
    const { token, position, annotations, onClose } = this.props;
    const { isExpanded } = this.state;
    return (
      <Portal closeOnEsc closeOnOutsideClick isOpened>
        <div style={position} styleName="popup" onMouseLeave={onClose}>
          <div data-test="annotation-popup" styleName="wrap">
            <div data-test="annotation-popup-header" styleName="header">
              <div>
                <Tooltip content={`"${token}"`} placement="top">
                  <span styleName="title">{`"${token}"`}</span>
                </Tooltip>
                <span>{`(${annotations.length})`}</span>
              </div>
              <button
                className={cn({
                  'icon-triangle-arrow-up': isExpanded,
                  'icon-triangle-arrow-down': !isExpanded,
                })}
                data-test={isExpanded ? 'arrow-up' : 'arrow-down'}
                onClick={this.handleClick}
              />
            </div>
            <div styleName="list">
              {annotations.map(item => (
                <Annotation
                  key={item.id + item.level}
                  color={item.color}
                  data-test="entity-name"
                  features={item.features}
                  isExpanded={isExpanded}
                  name={item.name}
                  token={item.token}
                  onClose={onClose}
                />
              ))}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}
